import ServicePageLayout from "@/components/ServicePageLayout";
import { CTABand } from "@/components/home/HomeSections";
import { Cloud, ShieldCheck, Headphones, Network, GitBranch, DatabaseBackup } from "lucide-react";
import { IMAGES } from "@/data/content";

export default function ItCloudSecurity() {
  return (
    <ServicePageLayout
      eyebrow="IT, Cloud & Security"
      title="Infrastructure that just works — and stays safe"
      intro="Cloud migration, 24/7 managed IT support and zero-trust cybersecurity for organisations that cannot afford downtime or data loss."
      image={IMAGES.cloud}
      imageAlt="Cloud infrastructure managed by TechAxis"
      offerings={[
        { icon: Cloud, title: "Cloud migration & architecture", desc: "AWS, Azure and GCP landing zones, migrations and cost optimisation with clear, documented architecture." },
        { icon: Headphones, title: "24/7 managed IT support", desc: "UK-based helpdesk, proactive monitoring and SLA-backed response times your team can rely on." },
        { icon: ShieldCheck, title: "Cybersecurity & zero trust", desc: "Audits, penetration testing, endpoint protection and identity-first zero-trust architecture." },
        { icon: Network, title: "Network solutions", desc: "Office and multi-site networking, secure Wi-Fi, VPN and SD-WAN design and installation." },
        { icon: GitBranch, title: "DevOps & CI/CD", desc: "Automated pipelines, infrastructure as code and observability so releases become routine." },
        { icon: DatabaseBackup, title: "Backup & disaster recovery", desc: "Tested recovery plans with defined RPO/RTO — because a backup you haven't restored is a hope, not a plan." },
      ]}
      process={[
        { title: "Audit & risk assessment", desc: "We map your current estate, risks and quick wins — delivered as a plain-English report." },
        { title: "Design & plan", desc: "Target architecture, migration waves and a costed roadmap agreed with your stakeholders." },
        { title: "Migrate & secure", desc: "Phased execution with rollback plans, security hardening and zero-surprise cutovers." },
        { title: "Operate & optimise", desc: "24/7 monitoring, monthly reviews and continuous cost and security optimisation." },
      ]}
      stack={["AWS", "Azure", "GCP", "Kubernetes", "Terraform", "Docker", "Zero Trust", "SIEM", "Entra ID", "Cloudflare"]}
    >
      <CTABand />
    </ServicePageLayout>
  );
}
